/**
 * Destino de Civitatis por provincia del PMS (`roomData.provinceId`), copiado de la app actual
 * (`src/libs/civitatis/utils/citivatisProvinceIdMap.ts`, solo las provincias con destino). Se usa cuando la reserva no
 * trae `civitatisId` (D14, fase 4 A8).
 */
export const CIVITATIS_DESTINATION_BY_PROVINCE: Readonly<Record<string, string>> = {
  'edc861d3-e7cd-11e4-b0f0-101f74f893a2': '153', // A coruña
  'edb905ac-e7cd-11e4-b0f0-101f74f893a2': '3908', // Albacete
  'edbb6f1f-e7cd-11e4-b0f0-101f74f893a2': '95', // Alicante
  'edbcfa68-e7cd-11e4-b0f0-101f74f893a2': '154', // Almeria
  'edbd8250-e7cd-11e4-b0f0-101f74f893a2': '299', // Avila
  'edbe1213-e7cd-11e4-b0f0-101f74f893a2': '180', // Badajoz
  'edbf27bd-e7cd-11e4-b0f0-101f74f893a2': '35', // Barcelona
  'edc2671c-e7cd-11e4-b0f0-101f74f893a2': '308', // Burgos
  'edc325b2-e7cd-11e4-b0f0-101f74f893a2': '138', // Caceres
  'edc4a8ff-e7cd-11e4-b0f0-101f74f893a2': '119', // Cadiz
  'edde9551-e7cd-11e4-b0f0-101f74f893a2': '2741', // Ceuta
  'edc7467c-e7cd-11e4-b0f0-101f74f893a2': '3476', // Ciudad real
  'edc7d8ab-e7cd-11e4-b0f0-101f74f893a2': '81', // Cordoba
  'edc8e56a-e7cd-11e4-b0f0-101f74f893a2': '53', // Cuenca
  'edbd8250-e7cd-11e4-b0f0-101f74f895R6': '49', // Eivissa y formentera
  'edbd8250-e7cd-11e4-b0f0-101f74f892R6': '306', // El hierro
  'edbd8250-e7cd-11e4-b0f0-101f74f893R6': '146', // Fuerteventura
  'edc9859d-e7cd-11e4-b0f0-101f74f893a2': '71', // Girona
  'edbd8250-e7cd-11e4-b0f0-101f74f894R6': '110', // Gran canaria
  'edcba4ea-e7cd-11e4-b0f0-101f74f893a2': '52', // Granada
  'edcc327b-e7cd-11e4-b0f0-101f74f893a2': '3004', // Guadalajara
  'edcafe6a-e7cd-11e4-b0f0-101f74f893a2': '20', // Guipuzkoa
  'edccbfa9-e7cd-11e4-b0f0-101f74f893a2': '147', // Huelva
  'edcd5c24-e7cd-11e4-b0f0-101f74f893a2': '2725', // Huesca
  'edcdd90b-e7cd-11e4-b0f0-101f74f893a2': '292', // Jaen
  'edbd8250-e7cd-11e4-b0f0-101f74f896R6': '210', // La gomera
  'edbd8250-e7cd-11e4-b0f0-101f74f897R6': '157', // La palma
  'edd68cd0-e7cd-11e4-b0f0-101f74f893a2': '26', // La rioja
  'edbd8250-e7cd-11e4-b0f0-101f74f898R6': '134', // Lanzarote
  'edd55b58-e7cd-11e4-b0f0-101f74f893a2': '4267', // Las palmas
  'edce6441-e7cd-11e4-b0f0-101f74f893a2': '158', // Leon
  'edcfd5c5-e7cd-11e4-b0f0-101f74f893a2': '339', // Lleida
  'edd06083-e7cd-11e4-b0f0-101f74f893a2': '195', // Lugo
  'edd0e205-e7cd-11e4-b0f0-101f74f893a2': '2', // Madrid
  'edd169ab-e7cd-11e4-b0f0-101f74f893a2': '83', // Malaga
  'edbd8250-e7cd-11e4-b0f0-101f74f89FR6': '80', // Mallorca
  'eddf23e4-e7cd-11e4-b0f0-101f74f893a2': '1411', // Melilla
  'edbd8250-e7cd-11e4-b0f0-101f74f891R6': '4', // Menorca
  'edd2066c-e7cd-11e4-b0f0-101f74f893a2': '399', // Murcia
  'edd34206-e7cd-11e4-b0f0-101f74f893a2': '1291', // Ourense
  'edd4ca61-e7cd-11e4-b0f0-101f74f893a2': '440', // Palencia
  'edd5f13b-e7cd-11e4-b0f0-101f74f893a2': '1152', // Pontevedra
  'edd71fc0-e7cd-11e4-b0f0-101f74f893a2': '124', // Salamanca
  'edd88709-e7cd-11e4-b0f0-101f74f893a2': '4240', // Santa cruz de tenerife
  'edd92309-e7cd-11e4-b0f0-101f74f893a2': '72', // Segovia
  'edd9d07f-e7cd-11e4-b0f0-101f74f893a2': '57', // Sevilla
  'edda6289-e7cd-11e4-b0f0-101f74f893a2': '2152', // Soria
  'eddae5c6-e7cd-11e4-b0f0-101f74f893a2': '166', // Tarragona
  'edbd8250-e7cd-11e4-b0f0-101f74f899R6': '109', // Tenerife
  'eddb6450-e7cd-11e4-b0f0-101f74f893a2': '778', // Teruel
  'eddbeb10-e7cd-11e4-b0f0-101f74f893a2': '79', // Toledo
  'eddc78a9-e7cd-11e4-b0f0-101f74f893a2': '120', // Valencia
  'eddcfeda-e7cd-11e4-b0f0-101f74f893a2': '12', // Valladolid
  'eddd7cab-e7cd-11e4-b0f0-101f74f893a2': '1066', // Zamora
  'edde0a13-e7cd-11e4-b0f0-101f74f893a2': '165', // Zaragoza
}
